export enum CONSTRUCTION_TYPE {
    TROCKEN = 1712,
}
export enum COUNTRY  {
    Germany = 'DE',
    UnitedKingdom = 'UK',
}
export const hasValue = (value?: string | number | null): boolean => value !== null && value !== undefined